
import extend from './util/extend';
import schemes from './schemes/bright';

export default function (msgs, options) {
    if (options.enabled === false) return;

    // default options
    var o = extend({
        enabled: true,
        prefix: 'logger.js',
        prefixLengthMin: 22,
        prefixColor: 'bg1',
        background: false,

        type: 'log',

        darkMode: (function () {
            return (typeof window !== 'undefined' && window.matchMedia('(prefers-color-scheme: dark)').matches);
        })(),

        seperators: {
            default: ' | ',
            prefix: ' › '
        },

        syntax: {
            oomph: '*',
            bad: '~',
            good: '_'
        }
    }, options);


    var colors = (o.darkMode ? schemes.dark : schemes.light);
    var commonStyles = `;
        font-weight: normal;
        -webkit-font-smoothing: antialiased;` +
        (o.background ? `background: ${colors.bg3}; ` : '');


    var styles = {
        default: 'color: ' + colors.base0 + commonStyles,
        prefix: 'color: ' + colors[o.prefixColor] + commonStyles,
        sep: 'color: ' + colors.bg0 + commonStyles,
        value: 'color: ' + colors.base1 + commonStyles,
        group: 'color: ' + colors.base0 + commonStyles,

        oomph: 'color: ' + colors.base3 + commonStyles,
        emph: 'color: ' + colors[o.prefixColor] + commonStyles,
        good: 'color: ' + colors.green + commonStyles
    };


    var fn = {
        applyStyle: function (msg, delim, style, params) {
            var newMsg, splitMsg;

            newMsg = '';
            splitMsg = msg.split(delim);

            if (splitMsg.length > 1) {
                splitMsg.forEach(function (submsg, i) {
                    newMsg = newMsg + '%c' + submsg;
                    params.push((i % 2 === 1 ? style : styles.default));
                });

                return newMsg;
            } else {
                return msg;
            }
        },

        logArray: function (msgs) {
            var finalMsg = '%c' + o.prefix;

            /*
            var prefixTooShortBy = o.prefixLengthMin - o.prefix.length;
            if (prefixTooShortBy > 0) {
                for (var i = 0; i < prefixTooShortBy; i++) {
                    finalMsg = finalMsg + ' ';
                }
            }
            */

            finalMsg = finalMsg + '%c' + o.seperators.prefix;
            var params = [styles.prefix, styles.sep];

            msgs.forEach(function (msg, i) {
                msg = '%c' + msg;
                params.push(styles.default);
                msg = fn.applyStyle(msg, o.syntax.oomph, styles.oomph, params);
                msg = fn.applyStyle(msg, o.syntax.bad, styles.emph, params);
                msg = fn.applyStyle(msg, o.syntax.good, styles.good, params);

                finalMsg = finalMsg + msg;

                if (i !== msgs.length - 1) {
                    finalMsg = finalMsg + '%c' + o.seperators.default;
                    params.push(styles.sep);
                }
            });

            params.unshift(finalMsg);

            console[o.type].apply(null, params);
        },

        logObject: function (msgs) {
            var intialGroupMsg = '%c' + o.prefix;

            console.group(intialGroupMsg, styles.prefix);

            var logObjKeys = function (obj, level) {
                level = level || 0;

                for (var key in obj) {
                    if (typeof obj[key] === 'object' && level < 2) {
                        // keep going recurssively through children object
                        var groupMsg = '%c' + key + '%c: ';
                        level++;
                        if (level > 0) {
                            console.groupCollapsed(groupMsg, styles.value, styles.sep);
                        } else {
                            console.group(groupMsg, styles.value, styles.sep);
                        }
                        logObjKeys(obj[key], level);
                        console.groupEnd();
                        level--;
                    } else {
                        // otherwise, print out
                        var msg = '%c' + key + '%c: %c' + obj[key];
                        var params = [styles.default, styles.sep, styles.value];

                        var finalMsg = msg;

                        params.unshift(finalMsg);

                        console.log.apply(null, params);
                    }
                }
            };

            logObjKeys(msgs);

            console.groupEnd();
        }
    };


    var init = function () {
        if (!o.enabled) return;

        // make into array if not already
        if (typeof msgs === 'string') {
            msgs = [msgs];
            fn.logArray(msgs);
        } else if (Array.isArray(msgs)) {
            fn.logArray(msgs);
        } else if (typeof msgs === 'object') {
            fn.logObject(msgs);
        } else {
            console.log(msgs);
        }
    };


    init();
};
